/* Enavi Sub-CTA Trust Icons in Cart Drawer */
document.addEventListener('rebuy:smartcart.show', (event) => {
  var newElement = document.createElement('div');
  newElement.className = 'custom-icon-wrapper';
  newElement.innerHTML=`<div class="custom-icon">
    <div class="icon-block"><svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" >
    <path d="M0 0h48v48H0z" fill="none"/>
    <g id="Shopicon">
    <path d="M10,22v2c0,7.72,6.28,14,14,14s14-6.28,14-14s-6.28-14-14-14h-4V4l-8,8l8,8v-6h4c5.514,0,10,4.486,10,10s-4.486,10-10,10
    s-10-4.486-10-10v-2H10z"/>
    </g>
    </svg>Covered by our 30 Day Flexible Return Policy</div>
    <div class="icon-block"><svg viewBox="0 0 24 24" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-1{fill:none;stroke:#020202;stroke-miterlimit:10;stroke-width:1.95px;}</style></defs><polygon class="cls-1" points="12 22.22 21.77 17.34 21.77 6.59 12 1.78 2.23 6.59 2.23 17.34 12 22.22"/><polyline class="cls-1" points="2.23 6.59 12 11.39 12 22.22"/><polyline class="cls-1" points="12 22.22 12 11.39 21.77 6.59"/><polyline class="cls-1" points="21.77 6.59 12 11.39 2.23 6.59"/></svg>
    Orders ship within 1 business day
    </div>
    </div>`;
    if(document.querySelector('[data-rebuy-cart-anchor="footer"] .custom-icon-wrapper')){
      document.querySelector('[data-rebuy-cart-anchor="footer"] .custom-icon-wrapper').remove();
    }
    //document.querySelector('.rebuy-cart__flyout-footer').appendChild(newElement);
    document.querySelector('[data-rebuy-cart-anchor="footer"]').appendChild(newElement);
});
/* Enavi Sub-CTA Trust Icons in Cart Drawer */

document.addEventListener("DOMContentLoaded", (event) => {

  /* Enavi Short Description */
  var description = document.querySelector(".short-description");
  if (description.scrollHeight > 3.5 * parseFloat(window.getComputedStyle(description).lineHeight)) {
    var btn = document.createElement("button");
    btn.textContent = "Read More";
    btn.classList.add("read-more-btn");
    description.parentElement.appendChild(btn);
    btn.style.display = "block";
    btn.addEventListener("click", function() {
      if (description.style.maxHeight) {
        description.style.maxHeight = null;
        btn.textContent = "Read More";
      } else {
        // If content is collapsed, expand it
        description.style.maxHeight = "100%";
        btn.textContent = "Read Less";
      }
      btn.style.display = "none";
    });
  }
   /* Enavi Short Description */
});
/* Enavi Mini cart */
document.addEventListener("DOMContentLoaded", (event) => {
  if (!document.querySelector("#mini-cart-container-new")) {
    let miniCartContainer = document.createElement("div");
    miniCartContainer.id = "mini-cart-container-new";
    document.body.appendChild(miniCartContainer);
  }

  setTimeout(function () {
    fetch('/cart.json')
      .then(res => res.json())
      .then(cart => {
        if (cart.item_count >= 1) {
          updateMiniCart(null);
        }
      });
  }, 2000);

  function updateMiniCart(addedItem) {
    fetch('/cart.json')
      .then(res => res.json())
      .then(cart => {
        updateStickyCart(cart);
      });
  }
document.addEventListener('rebuy:cart.add', (event) => { 
  Rebuy.SmartCart.skip_open = true;
  updateMiniCart(null);
});
document.addEventListener('rebuy:cart.change', (event) => { 
  updateMiniCart(null);
});
  // --- Update Sticky Cart UI ---
  function updateStickyCart(cart) {
    console.log(cart);
    const totalPriceFormatted = (cart.total_price / 100).toFixed(2);
    const cart_count = cart.item_count;
    document.querySelector('.site-header-cart--count').setAttribute('data-header-cart-count',cart_count);
    if(cart_count > 0){
      document.querySelector('.site-header-cart--count').classList.add('visible');
    }
    else{
      document.querySelector('.site-header-cart--count').classList.remove('visible');
    }
    let miniCartHTML = `
      <div class="mini-cart-new">
        <div class="mini-cart-inner-new">
          <div class="mini-cart-header-new">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H1.33877H1.33883C1.61048 2.00005 2.00378 2.23945 2.10939 2.81599L2.10937 2.816L2.11046 2.82171L5.01743 18.1859C5.12011 18.7286 5.64325 19.0852 6.18591 18.9826C6.21078 18.9779 6.23526 18.9723 6.25933 18.9658C6.28646 18.968 6.31389 18.9692 6.34159 18.9692H18.8179H18.8181C19.0302 18.9691 19.2141 18.9765 19.4075 18.9842L19.4077 18.9842C19.5113 18.9884 19.6175 18.9926 19.7323 18.9959C20.0255 19.0043 20.3767 19.0061 20.7177 18.9406C21.08 18.871 21.4685 18.7189 21.8028 18.3961C22.1291 18.081 22.3266 17.6772 22.4479 17.2384C22.4569 17.2058 22.4642 17.1729 22.4699 17.1396L23.944 8.46865C24.2528 7.20993 23.2684 5.99987 21.9896 6H21.9894H4.74727L4.07666 2.45562L4.07608 2.4525C3.83133 1.12381 2.76159 8.49962e-05 1.33889 0H1.33883H1ZM5.12568 8L6.8227 16.9692H18.8178H18.8179C19.0686 16.9691 19.3257 16.9793 19.5406 16.9877L19.5413 16.9877C19.633 16.9913 19.7171 16.9947 19.7896 16.9967C20.0684 17.0047 20.2307 16.9976 20.3403 16.9766C20.3841 16.9681 20.4059 16.96 20.4151 16.9556C20.4247 16.9443 20.4639 16.8918 20.5077 16.7487L21.9794 8.09186C21.9842 8.06359 21.9902 8.03555 21.9974 8.0078C21.9941 8.00358 21.9908 8.00108 21.989 8H5.12568ZM20.416 16.9552C20.4195 16.9534 20.4208 16.9524 20.4205 16.9523C20.4204 16.9523 20.4199 16.9525 20.4191 16.953L20.416 16.9552ZM10.8666 22.4326C10.8666 23.2982 10.195 24 9.36658 24C8.53815 24 7.86658 23.2982 7.86658 22.4326C7.86658 21.567 8.53815 20.8653 9.36658 20.8653C10.195 20.8653 10.8666 21.567 10.8666 22.4326ZM18.0048 24C18.8332 24 19.5048 23.2982 19.5048 22.4326C19.5048 21.567 18.8332 20.8653 18.0048 20.8653C17.1763 20.8653 16.5048 21.567 16.5048 22.4326C16.5048 23.2982 17.1763 24 18.0048 24Z" fill="currentColor"></path>
            </svg>
            <div class="cart-price-new">
              <div class="add-text-new">Cart (${cart_count})</div>
              <div class="total-price-new">${document.body.getAttribute('data-currency-symbol')}${totalPriceFormatted}</div>
            </div>
          </div>
          <button id="view-cart-new" class="button-secondary">View Cart</button>
        </div>
      </div>
    `;

    let miniCart = document.querySelector("#mini-cart-container-new");
    if (!miniCart) {
      console.error("Mini-cart container not found!");
      return;
    }

    miniCart.innerHTML = miniCartHTML;
    miniCart.style.display = "block";
    document.body.classList.add("mini-cart-open-new");

    document.querySelector("#view-cart-new").addEventListener("click", function () {
      document.querySelector('.site-header-cart--button').click();
    });
  }
});

/* Enavi Mini cart */

// Enavi Header Menu Custom Code //
document.addEventListener("DOMContentLoaded", (event) => {
  const header = document.querySelector('header.site-header');
  if(window.innerWidth > 1023){
      const navmenus = document.querySelectorAll('.navmenu-item-parent');

  navmenus.forEach(navmenu => {
    navmenu.addEventListener('mouseenter', () => {
      setTimeout(() => {
        header.classList.add('menuopen');
      }, 400);
    });
    navmenu.addEventListener('mouseleave', () => {
      setTimeout(() => {
        header.classList.remove('menuopen');
      }, 400);
    });
  });
  }
})
// Enavi Header Menu Custom Code //

// 43-1-R-PDP-Sticky ATC //
document.addEventListener("DOMContentLoaded", () => {
  const targetPrice = document.querySelector(".product-pricing .product__price");
const stickyPrices = document.querySelectorAll(".sticky-price.product__price"); // ← multiple sticky prices

const atcForm = document.querySelector(".product-form--atc");
const stickyBars = document.querySelectorAll(".product-sticky"); // ← updated for multiple bars

const atcBtn = document.querySelector("[data-product-atc]");
const stickyAtcBtn = document.querySelector(".sticky-atc-btn");

// --- PRICE SYNC (now supports multiple sticky prices) ---
if (targetPrice && stickyPrices.length) {

  const updatePrice = () => {
    stickyPrices.forEach(stickyPrice => {
      stickyPrice.innerHTML = targetPrice.innerHTML;
    });
  };

  updatePrice();

  const priceObserver = new MutationObserver(updatePrice);
  priceObserver.observe(targetPrice, { childList: true, characterData: true, subtree: true });
}

// --- ATC BUTTON TEXT SYNC ---
if (atcBtn && stickyAtcBtn) {
  const updateAtcText = () => {
    stickyAtcBtn.innerHTML = atcBtn.innerHTML;
  };
  updateAtcText();

  const atcObserver = new MutationObserver(updateAtcText);
  atcObserver.observe(atcBtn, { childList: true, characterData: true, subtree: true });
}

// --- STICKY SHOW/HIDE ON SCROLL + BODY CLASS ---
if (atcForm && stickyBars.length) {

  function toggleSticky() {
    const rect = atcForm.getBoundingClientRect();
    const shouldShow = rect.bottom < 0; // true = show sticky

    stickyBars.forEach(bar => {
      bar.style.display = shouldShow ? "block" : "none";
    });

    // NEW: toggle body class
    document.body.classList.toggle("sticky-visible", shouldShow);
  }

  window.addEventListener("scroll", toggleSticky);
  toggleSticky();
}
});
// 43-1-R-PDP-Sticky ATC //